export default __webpack_public_path__ + "8f7853c1ecfcd83f01f1ab55f8b3453e.png";